<template>
    <v-card>
        <v-card-title>
            <span class="headline">Додавання відвідуваності лекції</span>
        </v-card-title>
        <v-card-text>

            <div v-if="activeStep === 1">
                <lecture-topic-selector :activeModule="activeModule" @selectedTopics="setSelectedTopics($event)"/>
            </div>

            <div v-if="activeStep === 2">
                <lecture-mark-selector :activeModule="activeModule" 
                               :selected-topics="selectedTopics"
                               :errors="errors"
							   :loadingSave="loadingSave"
                               @change="onChangeMarks($event)"/>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    text
                    @click.native="$emit('shouldClose')"
                    :disabled="loadingSave"
            >Відміна
            </v-btn>
            <v-btn
                    v-if="selectedTopics.length > 0 && activeStep === 1"
                    color="primary"
                    type="button"
                    @click="passNextStep(2)"
            >Далі
                <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
                    v-if="activeStep === 2 && !isSaved"
                    color="orange darken-1"
                    dark
                    type="button"
                    :disabled="loadingSave"
                    :loading="loadingSave"
                    @click="saveMarks"
            >Внести дані лекції
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import LoadingPlaceholder from "../../../common/LoadingPlaceholder";
    import LectureMarkSelector from "../../../common/marks-management/LectureMarkSelector";
    import HttpService from "../../../../HttpService";
    import {remapErrors} from "../../../../helpers/errorsHelper";
    import LectureTopicSelector from "@/components/common/marks-management/LectureTopicSelector";

    export default {
        props: {
            activeModule: {
                type: Object
            }
        },
        components: {
            LoadingPlaceholder,
            LectureTopicSelector,
            LectureMarkSelector
        },
        data: () => {
            return {
                activeStep: 1,

                selectedTopics: [],
                loading: false,
                lectureTopicsMarkValues: null,
                
                errors: {},
                loadingSave: false,
                isSaved: false, 
            }
        },
        mounted() {
          this.errors = {};  
        },
        methods: {
            setSelectedTopics(topics) {
                this.selectedTopics = topics;
            },
            passNextStep(stepNumber) {
                this.activeStep = stepNumber;
            },
            onChangeMarks(value) {
                this.lectureTopicsMarkValues = value;
            },
            saveMarks() {
                this.$ga.event('professor', 'addMarks', 'groupId', this.$route.params.group);

                this.loadingSave = true;
                HttpService.getInstance()
                    .post(`teacher/teacherLectureMarks`,
                        {
                            ...this.lectureTopicsMarkValues,
                            ...{
                                professor: {id: 1},
                                department: {id: this.$route.params.department},
                                subject: {id: this.$route.params.subject},
                                module: {id: this.activeModule.id},
                                academicGroup: {id: this.$route.params.group},
                            }
                        }
                    )
                    .then(resp => {
                        this.loadingSave = false;
                        this.isSaved = true;
                        this.$emit('shouldSaveAndClose');
                        this.$store.commit('snackMessages/set', {message: "Відвідуваність лекції успішно внесена", color: 'success'});
                    })
                    .catch(err => {
                        this.loadingSave = false;
                        if (err.errors) {
                            this.errors = remapErrors(err.errors);
                        }
                    });
            }
        }
    }
</script>